module.exports = __webpack_public_path__ + "static/media/eng_d_2470.fb786215.mp4";